'use client';

import { Suspense } from 'react';

import LoginForm from '@/components/app/auth/login-form';

export default function Login() {
    return (
        <div>
            <Suspense>
                <LoginForm /> {/* Or whatever component uses useSearchParams */}
            </Suspense>
        </div>
    );
}
